import { useBoard } from './store';
import { buildEditorActions, MenuRow } from './ContextMenu';
import { Dialog } from '../ui/overlays';
import { useMedia } from '../ui/responsive';
import { useEditorUI } from './ui';

export function SelectionToolbar({ accent }: { accent: string }) {
  const board = useBoard();
  const { overlay, open, interacting } = useEditorUI();
  const phone = useMedia('(max-width: 767px)');
  if (
    interacting ||
    !board.canEdit ||
    !board.sel.length ||
    board.editing ||
    board.gesturing ||
    board.marquee ||
    board.frameDraft ||
    board.drawPts ||
    board.menu ||
    board.tool !== 'select'
  )
    return null;
  const id = board.sel[0];
  const rows = buildEditorActions(
    { id, sx: 0, sy: 0, wx: 0, wy: 0, isStroke: !!board.strokeById(id) },
    board,
    (run) => () => {
      run();
      open(null);
    },
  );
  const compact = rows.filter(
    (row) =>
      row.kind === 'swatches' ||
      row.kind === 'sizes' ||
      (row.kind === 'button' && /^(Duplicate|Edit text|Rename area|Group |Ungroup)/.test(row.label)),
  );
  return (
    <>
      <div
        className="sp-selection-toolbar"
        role="toolbar"
        aria-label="Selection actions"
        style={!phone && board.sandbox ? { top: 86 } : undefined}
      >
        <span className="sp-selection-count">{board.sel.length} selected</span>
        {!phone && compact.map((row, index) => <MenuRow key={index} row={row} accent={accent} itemRole="button" />)}
        <button className="sp-button" onClick={() => open('selection')}>
          {phone ? 'Edit selection' : 'More'}
        </button>
        <button className="sp-icon" aria-label="Deselect" onClick={() => board.setSel([])}>
          ×
        </button>
      </div>
      {overlay === 'selection' && (
        <Dialog title="Edit selection" drawer onClose={() => open(null)}>
          <div role="menu" aria-label="Selected item actions">
            {rows.map((row, index) => (
              <MenuRow key={index} row={row} accent={accent} />
            ))}
          </div>
        </Dialog>
      )}
    </>
  );
}
